import { useState, useEffect } from 'react';
import { auth } from '@strapi/helper-plugin';
import getConfig from '#shared/api/getConfig';

const useLaunchDarkly = () => {
  const [ldClientId, setLdClientId] = useState();
  const [environment, setEnvironment] = useState();
  const [userKey, setUserKey] = useState();
  const [userId, setUserId] = useState();
  
  const user = auth.getUserInfo();

  const getLDContextData = async () => {
    const configData = await getConfig();
    setLdClientId(configData.ldClientSideId);
    setEnvironment(configData.environment);
    setUserKey(getUserKey(configData.environment, user.id))
    setUserId(user.id)
  };

  const getUserKey = (env, id) => {
    const userKey = `${env}-user-${id}`;
    return userKey;
  };

  useEffect(() => {
    getLDContextData();
  }, []);

  return {
    ldClientId,
    environment,
    userKey,
    userId,
  };
};

export default useLaunchDarkly;
